module.exports = __webpack_public_path__ + "img/product28801.c3d686d4.png";